import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from 'src/app/pages/login/login.service';

export const authGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);
  const loginService = inject(LoginService);


  const falseReturn = () => {
    // router.navigate(['/login']);
    // Guardar la URL a la que intentaba acceder el usuario y redirigirlo al login
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  if(loginService.loggedInGuard()){
    return true;
  }else{
    return falseReturn();
  }
};
